:host {
  position: relative;
  display: inline-block;
  width: initial;
  height: auto;

  /* if the tooltip is inside a "pointer-events: none" component, make sure it works */
  pointer-events: var(--tooltip-pointer-event, all);
}

:host([isellipsis]) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:host([tooltipClass='error']) {
    color: var(--red-layout-300-primary);
  }
}
